import i18n from "@src/common/lib/i18n";
import { Dic } from "$utils";
export const deviceTableOption = function (deviceShow, areaShow) {
  return {
    add: "新增",
    edit: "修改",
    view: "详情",
    stripe: true,
    page: true,
    maxHeight: "100%",
    align: "center",
    header: false,
    selection: true,
    emptyText: i18n.t("cameraList.title.noData"),
    delBtn: false,
    editBtn: false,
    labelSuffix: "：",
    menu: false,
    menuWidth: 110,
    column: [
      {
        label: "类型",
        prop: "type",
        align: "center",
        hide: true,
        overHidden: true,
        viewDisplay: false,
        formatter: (row, value) => {
          if (Number(row.type) === 2) {
            return "部件";
          } else if (Number(row.type) === 27) {
            return "消防主机";
          } else if (Number(row.type) === 28) {
            return "喷雾主机";
          } else if (Number(row.type) === 29) {
            return "放烟排烟主机";
          }
          // return Number(row.type) === 1 ? '主机' : '部件'
        },
        viewFormatter: (row, value) => {
          // return Number(row.type) === 1 ? '主机' : '部件'
          if (Number(row.type) === 2) {
            return "部件";
          } else if (Number(row.type) === 27) {
            return "消防主机";
          } else if (Number(row.type) === 28) {
            return "喷雾主机";
          } else if (Number(row.type) === 29) {
            return "放烟排烟主机";
          }
        }
      },
      {
        label: "设备类型",
        prop: "deviceMark",
        align: "center",
        overHidden: true,
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU087", Number(value));
        },
        formatter: (row, value) => {
          return value ? Dic.findByValue("SENU087", value) : "";
        }
      },
      {
        label: "主机编号",
        prop: "parentMac",
        overHidden: true
      },
      {
        label: "主机名称",
        prop: "parentDeviceName",
        overHidden: true,
        search: true,
        span:24
      },
      // {
      //   label: '主机说明',
      //   prop: 'parentThirdDeviceDesc',
      //   align: 'center',
      //   overHidden: true
      // },
      {
        label: "厂商",
        prop: "factoryName",
        hide: true,
        overHidden: true
      },
      {
        label: "消防型号",
        prop: "deviceVersion",
        overHidden: true,
        hide: true,
        viewDisplay: true,
        type: "select",
        dicData: Dic.find("SENU095"), //SENU095
        rules: [
          {
            required: true,
            message: "请选择消防型号",
            trigger: "blur"
          }
        ],
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU095", Number(value));
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU095", value) : "";
        }
      },
      // {
      //   label: 'IP地址',
      //   prop: 'ip',
      //   overHidden: true
      // },
      {
        label: "唯一标识号",
        prop: "thirdDeviceId",
        align: "center",
        overHidden: true,
        search: true
      },
      // {
      //   label: '系统地址',
      //   prop: 'parentMac',
      //   overHidden: true,
      //   align: 'center'
      // },
      // {
      //   label: '类型标志',
      //   prop: 'typeMark',
      //   overHidden: true
      // },
      {
        label: "设备组",
        prop: "deviceWorkGroupName",
        overHidden: true,
        hide: areaShow
      },
      {
        label: "区域",
        prop: "areaName",
        overHidden: true,
        hide: deviceShow
      },
      {
        label: "状态",
        prop: "status",
        overHidden: true,
        addDisplay: true,
        viewDisplay: true,
        type: "select",
        dicData: [
          {
            label: "在线",
            value: "1"
          },
          {
            label: "离线",
            value: "0"
          }
        ],
        formatter: function (row, value) {
          return Number(value) === 1 ? "在线" : "离线";
        },
        viewFormatter: (row, value) => {
          return Number(value) === 1 ? "在线" : "离线";
        }
      },
      // {
      //   label: '回路',
      //   prop: 'loop',
      //   overHidden: true
      // },
      {
        label: "部件名称",
        prop: "deviceName",
        overHidden: true,
        search: true
      },
      {
        label: "部件型号",
        prop: "subDeviceMark",
        type: "select",
        dicData: Dic.find("SENU094"),
        viewFormatter: (row, value) => {
          return Dic.findByValue("SENU094", Number(value));
        },
        formatter: function (row, value) {
          return value ? Dic.findByValue("SENU094", value) : "";
        }
      },
      {
        label: "部件地址",
        prop: "mac",
        align: "center",
        overHidden: true
      },
      // {
      //   label: '二次码',
      //   prop: 'secondaryCode',
      //   align: 'center',
      //   overHidden: true
      // },
      // {
      //   label: '部件说明',
      //   prop: 'thirdDeviceDesc',
      //   align: 'center',
      //   overHidden: true
      // },
      {
        label: "创建时间",
        prop: "createrTime",
        align: "center",
        overHidden: true
      }
    ]
  };
};
